import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginLayoutComponent } from './shared/layouts/login-layout/login-layout.component';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { RegisterLayoutComponent } from './shared/layouts/register-layout/register-layout.component';
import { OnboardingsLayoutComponent } from './shared/layouts/onboardings-layout/onboardings-layout.component';
import { AdminLoginLayoutComponent } from './shared/layouts/admin/admin-login-layout/admin-login-layout.component';

import { AuthGuardAdmin } from './shared/guards/admin.guard';
import { AdminRedirectGuard } from './shared/guards/admin-redirect.guard';
import { CorporateAccountIdQueryResolver } from './core/resolvers/corporate-account-id-query.resolver';
import { TenantResolver } from './core/resolvers/tenant.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'xavi-pay/home',
    pathMatch: 'full',
  },
  {
    path: ':tenant',
    redirectTo: ':tenant/home',
    pathMatch: 'full',
  },
  {
    path: ':tenant/home',
    data: { title: 'Plataforma OZ' },
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('./pages/home').then((m) => m.HomeModule),
  },
  {
    path: ':tenant/register/:personType',
    data: { title: 'Plataforma OZ' },
    component: RegisterLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/register').then((m) => m.RegisterModule),
      },
    ],
    resolve: { tenant: TenantResolver },
  },
  {
    path: ':tenant/login',
    data: { title: 'Plataforma OZ' },
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/login').then((m) => m.LoginModule),
      },
    ],
    resolve: { tenant: TenantResolver },
  },
  {
    path: ':tenant/orders/:rType',
    data: { title: 'Plataforma OZ' },
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/orders').then((m) => m.OrdersModule),
      },
    ],
  },
  /*
   {
    path: ':tenant/account',
    data: { title: 'Plataforma OZ - Meus dados' },
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/account').then((m) => m.AccountModule),
      },
    ],
  }, 
   */
  {
    path: ':tenant/saved-contacts',
    data: { title: 'Plataforma OZ - Contatos' },
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/saved-contacts').then((m) => m.SavedContactsModule),
      },
    ],
  },

  {
    path: ':tenant/onboardings',
    data: { title: 'Plataforma OZ' },
    canActivate: [AuthGuard],
    component: OnboardingsLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/onboardings').then((m) => m.OnboardingsModule),
      },
    ],
  },
  {
    path: 'admin',
    data: { title: 'Plataforma OZ - Admin' },
    redirectTo: 'xavi-pay/admin/home/1',
    pathMatch: 'full',
  },
  {
    path: ':tenant/admin',
    data: { title: 'Plataforma OZ - Admin' },
    redirectTo: ':tenant/admin/home/1',
    pathMatch: 'full',
  },
  {
    path: ':tenant/admin/login',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard],
    component: AdminLoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/login').then((m) => m.LoginModule),
      },
    ],
  },
  {
    path: ':tenant/admin/home/:rType',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard, AuthGuardAdmin],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/home').then((m) => m.HomeModule),
      },
    ],
  },
  {
    path: ':tenant/admin/clients',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard, AuthGuardAdmin],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/clients').then((m) => m.ClientsModule),
      },
    ],
  },
  {
    path: ':tenant/admin/partners',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard, AuthGuardAdmin],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/partners').then((m) => m.PartnersModule),
      },
    ],
  },
  {
    path: ':tenant/admin/orders-history',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard, AuthGuardAdmin],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/orders-history').then(
            (m) => m.OrdersHistoryModule
          ),
      },
    ],
  },
  {
    path: ':tenant/admin/manage-quotation',
    data: { title: 'Plataforma OZ - Admin' },
    canActivate: [AdminRedirectGuard, AuthGuardAdmin],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/manage-quotation').then(
            (m) => m.ManageQuotationModule
          ),
      },
    ],
  },
  {
    path: 'xavi-pay/calculadora',
    loadChildren: () =>
      import('./pages/external-calculator/external-calculator.module').then(
        (m) => m.ExternalCalculatorModule
      ),
    resolve: { corporateAccountId: CorporateAccountIdQueryResolver },
  },
  {
    path: ':tenant/person-type',
    loadChildren: () =>
      import('./pages/external-person-type/external-person-type.module').then(
        (m) => m.ExternalPersonTypeModule
      ),
    data: { title: 'Plataforma OZ' },
    resolve: { tenant: TenantResolver },
  },
  {
    path: 'xavi-pay/v2/calculadora',
    loadChildren: () =>
      import(
        './pages/external-calculator-v2/external-calculator-v2.module'
      ).then((m) => m.ExternalCalculatorV2Module),
    resolve: { corporateAccountId: CorporateAccountIdQueryResolver },
  },
  {
    path: 'xavi-pay/agilize/calculadora',
    loadChildren: () =>
      import('./pages/agilize-calculator/agilize-calculator.module').then(
        (m) => m.AgilizeCalculatorModule
      ),
    resolve: { corporateAccountId: CorporateAccountIdQueryResolver },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
